// src/components/Expertise.js
import React from 'react';
import Card from './Card';
import './Expertise.css';
// Import icons from react-icons library
import { FaBrain, FaMicrochip, FaCity, FaCogs, FaCloud, FaShieldAlt } from 'react-icons/fa';

const Expertise = () => {
  // Data array now uses the Icon component directly instead of image paths
  const services = [
    {
      Icon: FaBrain,
      title: 'AI & SOFTWARE DEVELOPMENT',
      description: 'Custom AI, ML, and data science solutions, including SaaS platforms and mobile apps.',
    },
    {
      Icon: FaMicrochip,
      title: 'ELECTRONICS & IOT',
      description: 'Design, develop, and manufacture smart devices, sensors, and automation systems.',
    },
    {
      Icon: FaCity, // Changed to City icon for infrastructure
      title: 'CONSTRUCTION & SMART INFRA',
      description: 'Planning and execution of residential, commercial, and industrial projects with smart technology integration.',
    },
    {
      Icon: FaCogs,
      title: 'GENERAL ENGINEERING',
      description: 'Technical consultancy, project management, and turnkey engineering solutions.',
    },
    // --- 2 NEW SERVICES ADDED ---
    {
      Icon: FaCloud,
      title: 'CLOUD INTEGRATION',
      description: 'Scalable cloud architecture and migration services to support data-driven operations.',
    },
    {
      Icon: FaShieldAlt,
      title: 'CYBERSECURITY SOLUTIONS',
      description: 'Robust security frameworks to protect physical and digital assets in connected environments.',
    },
  ];

  return (
    <section className="expertise-section">
      <div className="container">
        <h2 className="section-title">OUR INTEGRATED EXPERTISE</h2>
        <div className="expertise-grid">
          {services.map((service, index) => (
            // Spread the service object props to the Card
            <Card key={index} {...service} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Expertise;